/** Max visible characters for invite name in visitor log tables before truncation. */
export const INVITE_NAME_MAX_DISPLAY_LENGTH = 20;

/** Max visible characters for custom field names and values in visitor log tables before truncation. */
export const VISITOR_CUSTOM_FIELD_MAX_DISPLAY_LENGTH = 25;
